import { createUseStyles } from "react-jss";
import bannerBg from "assets/images/bannerBg.png";
export const useStyles = createUseStyles({
  ecExclusiveWrapper: {
    backgroundColor: "var(--eSecondary)",
    minHeight: "100vh",
    fontFamily: "'Brawler', serif!important",
    "& .disable": {
      opacity: "0.6",
      pointerEvents: "none",
      filter: "grayscale(1)",
      cursor: "no-drop",
    },
    "& .topWrapper": {
      fontSize: "16px",
      padding: "10px 0",
      textAlign: "center",
      backgroundColor: "var(--eDark)",
      color: "var(--eTernary)",
    },
    "& .container": {
      maxWidth: "1316px",
      padding: "0 20px",
      margin: "0 auto",
    },
    "& .headerWrapper": {
      padding: "20px 0",
      "& .basket-icon.active": {
        position: "relative",
        "& .ePNum": {
          backgroundColor: "var(--ePrimary)",
          width: "20px",
          height: "20px",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "10px",
          borderRadius: "50%",
          color: "var(--white)",
          position: "absolute",
          right: "-8px",
          bottom: "0px",
        },
      },
      "& .disable": {
        "& .ePNum": {
          display: "none",
        },
      },
    },
    "& .bannerSection": {
      color: "var(--eTernary)",
      marginBottom: "75px",
      borderRadius: "20px",
      textAlign: "center",
      position: "relative",
      "& .bBg": {
        "& img": {
          height: "500px",
          objectFit: "cover",
          borderRadius: "20px",
        },
      },
      "& .bContent": {
        padding: "20px",
        position: "absolute",
        width: "100%",
        left: "50%",
        top: "50%",
        transform: "translate(-50%,-50%)",
        "& .bHeader": {
          "& .bLogo": {
            width: "100px",
            height: "100px",
            backgroundColor: "var(--eTernary)",
            borderRadius: "50%",
            "& img": {
              width: "100%",
              padding: "15px",
              height: "100%",
            },
          },
        },
        "& .bBody": {
          paddingTop: "30px",
          "& h2": {
            fontSize: "45px",
            marginBottom: "15px",
            fontWeight: "normal",
            "& span": {
              fontWeight: "bold",
            },
          },
          "& p": {
            fontWeight: "normal",
            "& span": {
              fontWeight: "bold",
            },
          },
        },
        "& .seperator": {
          margin: "30px 0",
          "& .sepLine": {
            width: "100px",
            height: "1px",
            backgroundColor: "var(--eTernary)",
          },
        },
        "& .bFooter": {
          "& p": {
            fontSize: "15px",
            fontWeight: "normal",
            textTransform: "capitalize",
            marginBottom: "5px",
          },
          "& .blockchains": {
            "& span": {
              "& svg": {
                width: "25px",
                height: "25px",
                backgroundColor: "var(--eTernary)",
                padding: "5px",
                borderRadius: "5px",
                "& path": {
                  // fill: "var(--ePrimary)",
                },
              },
              "& .ant-image .ant-image-img": {
                width: "25px",
                height: "25px",
                backgroundColor: "var(--eTernary)",
                padding: "5px",
                borderRadius: "5px",
                "& path": {
                  // fill: "var(--ePrimary)",
                },
              },
            },
          },
        },
      },
    },
    "& .productSection": {
      padding: "20px 0",
      "& .pHeader": {
        "& .left": {
          "& .pHeading": {
            textTransform: "uppercase",
            fontSize: "24px",
            fontWeight: "bold",
            color: "var(--ePrimary)",
            marginBottom: "10px",
          },
          "& .pText": {
            fontSize: "18px",
            fontWeight: "normal",
            color: "var(--ePrimary)",
          },
        },
        "& .right": {
          "& p": {
            fontSize: "14px",
            color: "var(--ePrimary)",
            fontWeight: "bold",
          },
          "& .ant-space": {
            border: "1px solid var(--ePrimary)",
            padding: "10px",
            display: "flex",
            width: "206px",
            justifyContent: "space-between",
            borderRadius: "5px",
            color: "var(--ePrimary)",
            "& .ant-space-item": {
              fontWeight: 600,
            },
            "& svg path": {
              fill: "var(--ePrimary)",
            },
          },
        },
      },
      "& .pBody": {
        marginTop: "50px",
        "& .pCard": {
          position: "relative",
          zIndex: "1",
          border: "2px solid rgb(97 51 35 / 10%)",
          fontFamily: "'Brawler', serif!important",
          marginTop: "100px",
          "&:before": {
            content: `""`,
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100px",
            backgroundColor: "var(--eTernary)",
            zIndex: "-1",
            borderRadius: "18px 18px 0 0",
          },
          padding: "25px",
          borderRadius: "20px",
          "& .pCardHeader": {
            textAlign: "center",
            marginTop: "-100px",
            "& img": {
              margin: "0 auto",
              display: "block",
            },
          },
          "& .pCardBody": {
            color: "var(--ePrimary)",
            "& .pCardTitle": {
              fontSize: "18px",
              marginTop: "20px",
              fontWeight: "bold",
              textTransform: "uppercase",
            },
            "& .pCardAmount": {
              fontSize: "24px",
              fontWeight: "normal",
              textTransform: "uppercase",
              margin: "10px 0 20px",
            },
            "& .pCardContent": {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "100%",
              display: "block",
              color: "var(--ePrimary)",
              fontSize: "14px",
            },
          },
          "& .pCardFooter": {
            marginTop: "20px",
            "& .left": {
              "& p": {
                textTransform: "uppercase",
                fontSize: "14px",
                cursor: "pointer",
                fontWeight: "bold",
                textDecoration: "underline",
                color: "var(--ePrimary)",
                "& svg": {
                  transition: "0.2s all ease-in-out",
                },
                "&:hover": {
                  textDecoration: "unset",
                  "& svg": {
                    marginLeft: "3px",
                  },
                },
              },
            },
            "& .right": {
              "& p": {
                fontSize: "11px",
                fontWeight: "bold",
                backgroundColor: "var(--eTernary)",
                textTransform: "uppercase",
                padding: "5px 15px",
                borderRadius: "30px",
                color: "var(--ePrimary)",
              },
            },
          },
        },
      },
    },
    "& .exfooterWrapper": {
      marginTop: "150px",
      padding: "20px 0",
      position: "relative",
      "&:after": {
        content: `""`,
        position: "absolute",
        top: "95px",
        left: "auto",
        background: "rgb(97 51 35 / 30%)",
        width: "100%",
        height: "1px",
      },
      "& .footerLogo": {
        backgroundColor: "var(--eSecondary)",
        position: "relative",
        width: "150px",
        height: "150px",
        borderRadius: "50%",
        border: "1px solid rgb(97 51 35 / 30%)",
        zIndex: "1",
        "& img": {},
      },
      "& p": {
        marginTop: "20px",
        color: "var(--ePrimary)",
        fontSize: "14px",
        fontWeight: "normal",
        "& span": {
          fontWeight: "bold",
        },
      },
    },
  },
});
